import { connect } from 'react-redux';
import {
  fetchStaff,
  setStaffForm,
  deleteStaff,
} from '../../../store/modules/staff';

import Staff from '../components/Staff';

const mapActionCreators = {
  fetchStaff,
  setStaffForm,
  deleteStaff,
};

const mapStateToProps = state => ({
  staff: state.staff.staffs[state.staff.current],
  staffs: state.staff.staffs,
  fetching: state.staff.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Staff);



// WEBPACK FOOTER //
// ./src/routes/Staff/containers/StaffContainer.js